// extracted by mini-css-extract-plugin
module.exports = {"root":"ArrowLinkIcon_root__s4yAL","arrowLinkIcon":"ArrowLinkIcon_arrowLinkIcon__lXwHv","static":"ArrowLinkIcon_static__HfxO_","isOpen":"ArrowLinkIcon_isOpen__8uBeb"};